// Shared navigation configuration
// Used by both React components and pattern page generator

export interface NavItem {
  id: string;
  anchor: string;
  translationKey: string;
  isPage?: boolean;
}

export interface LanguageConfig {
  code: string;
  nameKey: string;
}

export const navigation = {
  items: [
    { id: 'patterns', anchor: 'patterns', translationKey: 'header.patterns', isPage: true },
    { id: 'features', anchor: 'features', translationKey: 'header.features' },
    { id: 'abbreviation', anchor: 'abbreviation', translationKey: 'header.abbreviation' },
    { id: 'faq', anchor: 'faq', translationKey: 'header.faq' },
    { id: 'creators', anchor: 'creators', translationKey: 'header.creators', isPage: true },
  ] as NavItem[],

  languages: [
    { code: 'en', nameKey: 'English' },
    { code: 'de', nameKey: 'German' },
    { code: 'fr', nameKey: 'French' },
    { code: 'es', nameKey: 'Spanish' },
    { code: 'pt', nameKey: 'Portuguese' },
  ] as LanguageConfig[],

  mobileItems: [
    { id: 'download', anchor: 'download', translationKey: 'header.download' },
    { id: 'patterns', anchor: 'patterns', translationKey: 'header.patterns', isPage: true },
    { id: 'features', anchor: 'features', translationKey: 'header.features' },
    { id: 'abbreviation', anchor: 'abbreviation', translationKey: 'header.abbreviation' },
    { id: 'faq', anchor: 'faq', translationKey: 'header.faq' },
    { id: 'creators', anchor: 'creators', translationKey: 'header.creators', isPage: true },
  ] as NavItem[],
};
